import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  CreateMasterRequestBody,
  CreateMasterResponse,
  MasterApi,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useMutationCreateMaster = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: CreateMasterRequestBody,
    ): Promise<CreateMasterResponse> => {
      return await baseClient
        .getApi(MasterApi)
        .createMaster({ createMasterRequestBody: request })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.masters })
    },
  })
}
